export const URLs = {
  //CheckIn
  CHECKIN_STATUS: (storeID: string) => `/stores/${storeID}/checkin-status`,
  CHECKIN: (storeID: string) => `/stores/${storeID}/checkin`,
  CHECKOUT: (storeID: string) => `/stores/${storeID}/checkout`,
  checkIn: {
    create: (storeID: string, employeeID: string) =>
      `/stores/${storeID}/employees/${employeeID}/checkins`,
  },
  //Dashboard
  Dashboard: {
    totalBilled: (orgID: string) => `/orgs/${orgID}/dashboards/total-billed`,
    totalBookings: (orgID: string) => `/orgs/${orgID}/dashboards/total-bookings`,
    totalEmployees: (orgID: string) => `/orgs/${orgID}/dashboards/total-employees`,
    totalServices: (orgID: string) => `/orgs/${orgID}/dashboards/total-services`,
    productInventory: (orgID: string, query: string) =>
      `/orgs/${orgID}/dashboards/inventory-status${query}`,
  },

  //Auth
  LOGIN: '/login',
  LOGOUT: '/logout',
  REFRESH_TOKEN: '/refresh-token',

  //Rent Car
  RentCar: {
    availableRentCars: (storeID: string, query: string) =>
      `/stores/${storeID}/available-rentCars${query}`,
    create: (storeID: string) => `/stores/${storeID}/rent-cars`,
    byRegNum: (storeID: string, regNum: string) => `/stores/${storeID}/rent-cars/${regNum}`,
    list: (storeID: string, query: string) => `/stores/${storeID}/rent-cars${query}`,
    listHistory: (storeID: string, query: string) =>
      `/stores/${storeID}/rent-car-booking-history${query}`,
  },
  RENT_CAR: (storeID: string, query: string) => `/stores/${storeID}/rent-cars${query}`,

  //Stores
  STORES: (orgID: string) => `/orgs/${orgID}/stores`,

  Bookings: {
    create: (orgID: string, storeID: string) => `/orgs/${orgID}/stores/${storeID}/orders`,
    list: (orgID: string, storeID: string, query: string) =>
      `/orgs/${orgID}/stores/${storeID}/orders${query}`,

    update: (orgID: string, storeID: string, orderID: string) =>
      `/orgs/${orgID}/stores/${storeID}/orders/${orderID}`,

    kanban: (storeID: string, query: string) => `/stores/${storeID}/kanban${query}`,
  },
  DailyNotes: {
    put: (storeID: string) => `/stores/${storeID}/daily-notes`,
    list: (storeID: string, query: string) => `/stores/${storeID}/daily-notes${query}`,
  },
  Category: {
    byIDService: (orgID: string, serviceCategoryID: string) =>
      `/orgs/${orgID}/service-categories/${serviceCategoryID}`,
    byIDProduct: (orgID: string, productCategoryID: string) =>
      `/orgs/${orgID}/product-categories/${productCategoryID}`,
    createService: (orgID: string) => `/orgs/${orgID}/service-categories`,
    createProduct: (orgID: string) => `/orgs/${orgID}/product-categories`,
    listProduct: (orgID: string, query: string) => `/orgs/${orgID}/products-categories${query}`,
    listService: (orgID: string, query: string) => `/orgs/${orgID}/service-categories${query}`,
  },
  Companies: {
    byID: (orgID: string, companyOrgNumber: string) =>
      `/orgs/${orgID}/company-org-numbers/${companyOrgNumber}`,
    create: (orgID: string) => `/orgs/${orgID}/companies`,
    list: (orgID: string, query: string) => `/orgs/${orgID}/companies${query}`,
  },
  Customers: {
    byID: (orgID: string, driverID: string) => `/orgs/${orgID}/drivers/${driverID}`,
    create: (orgID: string) => `/orgs/${orgID}/drivers`,
    list: (orgID: string, query: string) => `/orgs/${orgID}/drivers${query}`,
  },
  EmailTemplates: {
    byID: (orgID: string, emailTemplateID: string) =>
      `/orgs/${orgID}/email-templates/${emailTemplateID}`,
    create: (orgID: string) => `/orgs/${orgID}/email-templates`,
    list: (orgID: string, query: string) => `/orgs/${orgID}/email-templates${query}`,
  },
  Employees: {
    byID: (orgID: string, employeeID: string) => `/orgs/${orgID}/employees/${employeeID}`,
    byUserID: (orgID: string, userID: string) => `/orgs/${orgID}/users/${userID}/employees`,
    create: (orgID: string) => `/orgs/${orgID}/employees`,
    list: (storeID: string, query: string) => `/stores/${storeID}/employees${query}`,
  },
  Permissions: {
    create: () => `/permissions`,
    getByID: (orgID: string, permissionID: string) => `/orgs/${orgID}/permissions/${permissionID}`,
    byID: (permissionID: string) => `/permissions/${permissionID}`,
    list: (orgID: string, query: string) => `/orgs/${orgID}/permissions${query}`,
  },
  Products: {
    byID: (storeID: string, productID: string) => `/stores/${storeID}/products/${productID}`,
    create: (orgID: string) => `/orgs/${orgID}/products`,
    delete: (orgID: string, productID: string, type: string) =>
      `/orgs/${orgID}/products/${productID}/type/${type}`,
    list: (orgID: string, storeID: string, query: string) =>
      `/orgs/${orgID}/stores/${storeID}/products${query}`,
    update: (orgID: string, productID: string, type: string) =>
      `/orgs/${orgID}/type/${type}/products/${productID}`,
  },
  Qualifications: {
    byIDGlobal: (orgID: string, globalQualID: string) =>
      `/orgs/${orgID}/global-qualifications/${globalQualID}`,
    byIDLocal: (storeID: string, localQualID: string) =>
      `/stores/${storeID}/local-qualifications/${localQualID}`,
    createGlobal: (orgID: string) => `/orgs/${orgID}/global-qualifications`,
    createLocal: (storeID: string) => `/stores/${storeID}/local-qualifications`,
    deleteGlobal: (orgID: string) => `/orgs/${orgID}/global-qualifications`,
    deleteLocal: (storeID: string) => `/stores/${storeID}/local-qualifications`,
    list: (orgID: string, query: string) => `/orgs/${orgID}/qualifications-list${query}`,
  },
  Users: {
    create: (orgID: string) => `/orgs/${orgID}/users`,
    createWithEmployee: (orgID: string) => `/orgs/${orgID}/users/employees`,
    byID: (orgID: string, userID: string) => `/orgs/${orgID}/users/${userID}`,
    update: (userID: string) => `/users/${userID}`,
    changePassword: (userID: string) => `/users/${userID}/update-password`,
    loginHistory: (orgID: string, userID: string) => `/orgs/${orgID}/users/${userID}/login-history`,
  },
  Roles: {
    create: (orgID: string) => `/orgs/${orgID}/roles`,
    byID: (orgID: string, roleID: string) => `/orgs/${orgID}/roles/${roleID}`,
    list: (orgID: string, query: string) => `/orgs/${orgID}/roles${query}`,
    rolesPermissionsMapping: (orgID: string, roleID: string) =>
      `/orgs/${orgID}/roles/${roleID}/role_with_permissions`,
  },
  Services: {
    byID: (orgID: string, type: string = 'Local', serviceID: string) =>
      `/orgs/${orgID}/types/${type}/services/${serviceID}`,
    create: (orgID: string, type?: string) => `/orgs/${orgID}/types/${type}/services`,
    list: (orgID: string, storeID: string, query: string) =>
      `/orgs/${orgID}/stores/${storeID}/services${query}`,
    createVariant: (orgID: string, storeID: string, serviceID: string) =>
      `/orgs/${orgID}/stores/${storeID}/services/${serviceID}/service-variant`,
    byIDVariant: (orgID: string, storeID: string, serviceID: string, serviceVariantID: string) =>
      `/orgs/${orgID}/stores/${storeID}/services/${serviceID}/service-variant${serviceVariantID}`,
  },
  SMSTemplates: {
    byID: (orgID: string, smsTemplateID: string) => `/orgs/${orgID}/sms-templates/${smsTemplateID}`,
    create: (orgID: string) => `/orgs/${orgID}/sms-templates`,
    list: (orgID: string, query: string) => `/orgs/${orgID}/sms-templates${query}`,
  },
  Stores: {
    create: (orgID: string) => `/orgs/${orgID}/stores`,
    byID: (orgID: string, storeID: string) => `/orgs/${orgID}/stores/${storeID}`,
    list: (orgID: string, query: string) => `/orgs/${orgID}/stores${query}`,
  },
  Vehicles: {
    byID: (orgID: string, driverCarID: string) => `/orgs/${orgID}/driver-cars/${driverCarID}`,
    byRegNumber: (orgID: string, driverCarRegistrationNumber: string) =>
      `/orgs/${orgID}/driver-car-regs/${driverCarRegistrationNumber}`,
    create: (orgID: string) => `/orgs/${orgID}/driver-cars`,
    delete: (orgID: string, driverCarID: string) => `/orgs/${orgID}/drivers-cars/${driverCarID}`,
    list: (orgID: string, query: string) => `/orgs/${orgID}/driver-cars${query}`,
    vehicleCustomerMap: (orgID: string, driverID: string) => `/orgs/${orgID}/driverIDs/${driverID}`,
  },
  Uploads: {
    create: (orgID: string) => `/orgs/${orgID}/uploads`,
    list: (orgID: string, query: string) => `/orgs/${orgID}/uploads${query}`,
    byID: (orgID: string, uploadID: string) => `/orgs/${orgID}/uploads/${uploadID}`,
    profilePic: (orgID: string, uploadID: string) =>
      `/orgs/${orgID}/uploads/${uploadID}/profile-pic`,
  },
  WeeklyNotes: {
    getWeeklyNotes: (storeID: string, week: string) => `/stores/${storeID}/week-notes/${week}`,
    put: (storeID: string) => `/stores/${storeID}/week-notes`,
  },
}
